import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import suppliersService from '../services/suppliersService';
import SupplierForm from '../components/SupplierForm';
import { useNotification } from '../context/NotificationContext';
import '../styles/general.css';

const SupplierFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { notify } = useNotification();
  const isEditMode = !!id;

  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(isEditMode);

  useEffect(() => {
    if (isEditMode) {
      const fetchSupplier = async () => {
        try {
          const res = await suppliersService.getSupplierById(id);
          setSupplier(res.data);
        } catch (err) {
          notify.error(t('common.failedToLoad'));
        } finally {
          setLoading(false);
        }
      };
      fetchSupplier();
    }
  }, [id, isEditMode, t, notify]);

  const handleSuccess = () => {
    setTimeout(() => navigate('/suppliers'), 1000);
  };

  if (loading) {
    return (
      <div className="loading">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <div className="page-container">
      <h1>
        {isEditMode ? t('suppliers.editTitle') : t('suppliers.createTitle')}
      </h1>

      <SupplierForm
        initialData={supplier}
        onSuccess={handleSuccess}
        onCancel={() => navigate('/suppliers')}
      />
    </div>
  );
};

export default SupplierFormPage;
